const $ba176e6f9cf2fcd5$var$PROD_URL = "https://insta-code-three.vercel.app";
const $ba176e6f9cf2fcd5$var$API_URL = window.location.hostname.includes("localhost") ? "http://localhost:3000/posts" : `${$ba176e6f9cf2fcd5$var$PROD_URL}/posts`;
async function $ba176e6f9cf2fcd5$export$2e2bcd8739ae039() {
    try {
        const response = await fetch($ba176e6f9cf2fcd5$var$API_URL); // Usando a URL importada
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Erro ao buscar dados:", error);
    }
}


const $c5df353ed277957a$var$modal = document.getElementById("modal");
const $c5df353ed277957a$var$modalImg = document.getElementById("modal-img");
const $c5df353ed277957a$var$captionText = document.getElementById("caption");
const $c5df353ed277957a$var$closeBtn = document.querySelector(".close");
$c5df353ed277957a$var$modal.style.display = "none";
const $c5df353ed277957a$var$imageGrid = document.querySelector(".image-grid");
const $c5df353ed277957a$var$prevBtn = document.getElementById("prev-btn");
const $c5df353ed277957a$var$nextBtn = document.getElementById("next-btn");
let $c5df353ed277957a$var$currentIndex = 0;
let $c5df353ed277957a$var$imagesData = [];
// Função para buscar e exibir os dados do endpoint
async function $c5df353ed277957a$var$displayImages() {
    const data = await (0, $ba176e6f9cf2fcd5$export$2e2bcd8739ae039)();
    $c5df353ed277957a$var$imagesData = data; // Armazena os dados para navegação
    try {
        const postsList = data.map((item, index)=>{
            // Added index to map
            const description = item.description || item.descricao;
            const imgUrl = item.imgUrl || item.img_url;
            return `
            <article data-index="${index}" data-description="${description}">
              <figure>
                <img src="${imgUrl}" alt="${item.alt}" />
              </figure>
            </article>
          `;
        }).join("");
        $c5df353ed277957a$var$imageGrid.insertAdjacentHTML("beforeend", postsList);
        // Adicionando eventos de clique para cada imagem carregada
        $c5df353ed277957a$var$addImageClickEvents();
    } catch (error) {
        console.error("Erro ao popular p\xe1gina", error);
    }
}
function $c5df353ed277957a$var$updateModal(index) {
    const item = $c5df353ed277957a$var$imagesData[index];
    if (!item) return;
    const description = item.description || item.descricao;
    const imgUrl = item.imgUrl || item.img_url;
    $c5df353ed277957a$var$modalImg.src = imgUrl;
    $c5df353ed277957a$var$modalImg.alt = item.alt;
    $c5df353ed277957a$var$captionText.innerHTML = `<p>${description || item.alt}</p>`;
    $c5df353ed277957a$var$currentIndex = index;
}
// Função para adicionar os eventos de clique às imagens
function $c5df353ed277957a$var$addImageClickEvents() {
    const articles = document.querySelectorAll(".image-grid article");
    articles.forEach((article)=>{
        article.addEventListener("click", function() {
            const index = parseInt(this.dataset.index);
            $c5df353ed277957a$var$modal.style.display = "flex";
            $c5df353ed277957a$var$updateModal(index);
        });
    });
}
// Eventos de navegação
$c5df353ed277957a$var$prevBtn.addEventListener("click", (e)=>{
    e.stopPropagation(); // Evita fechar o modal ao clicar no botão
    $c5df353ed277957a$var$currentIndex = $c5df353ed277957a$var$currentIndex > 0 ? $c5df353ed277957a$var$currentIndex - 1 : $c5df353ed277957a$var$imagesData.length - 1;
    $c5df353ed277957a$var$updateModal($c5df353ed277957a$var$currentIndex);
});
$c5df353ed277957a$var$nextBtn.addEventListener("click", (e)=>{
    e.stopPropagation(); // Evita fechar o modal ao clicar no botão
    $c5df353ed277957a$var$currentIndex = $c5df353ed277957a$var$currentIndex < $c5df353ed277957a$var$imagesData.length - 1 ? $c5df353ed277957a$var$currentIndex + 1 : 0;
    $c5df353ed277957a$var$updateModal($c5df353ed277957a$var$currentIndex);
});
// Evento de fechar o modal
$c5df353ed277957a$var$closeBtn.addEventListener("click", function() {
    $c5df353ed277957a$var$modal.style.display = "none";
});
// Fechar o modal clicando fora dele
window.addEventListener("click", function(event) {
    if (event.target === $c5df353ed277957a$var$modal) $c5df353ed277957a$var$modal.style.display = "none";
});
// Chamar a função para buscar e exibir as imagens ao carregar a página
document.addEventListener("DOMContentLoaded", $c5df353ed277957a$var$displayImages);


//# sourceMappingURL=frontend.6934f045.js.map
